import styled from "styled-components";
export const TimerContainer = styled.div `
	display: flex;
	align-items: center;
	justify-content: space-between;
	background-color: #F5F5F5;
	color: white;
	padding: 8px;
	border-radius: 4px;
	border: 1px solid #F5F5F5;
	& span {
		font-size: 14px;
		margin-left: 5px;
	}
	margin-bottom: 20px;
`;
export const Timer = styled.div `
	display: flex;
	align-items: center;
	gap: 8px;

	& span {
		color: #000000;
		font-weight: 600;
		font-size: 18px;
		line-height: 16px;
		margin-left: 0px;

		&.danger {
			color: #EA4335;
		}
	}

	& p {
		color: #313131;
		font-size: 14px;
		line-height: 16px;

		&.danger {
			color: #EA4335;
		}
	}
`;
export const TimerButton = styled.button `
	background-color: #313131;
	padding: 8px 16px;
	border: none;
	border-radius: 4px;
	font-size: 16px;
	line-height: 24px;
	color: white;

	&.active {
		background-color: #d9d9d9;
		color: #757575;
	}
`;
//# sourceMappingURL=index.js.map